import FilterProvider from 'views/Dashboard/ImplementData/components/Filter/Provider';
import ExtraNode from 'views/Dashboard/ImplementData/components/Filter/ExtraNode';
import { initialValue } from '../PerfReport/components/Robot';
import { useMemo } from 'react';
import { getRobotContributionOverview } from 'services/api/dashboard';
import { ctx2FetchParam } from 'views/Dashboard/ImplementData/utils';
import Banner from '../PerfReport/components/Robot/Banner';
import { useDashboardFilter } from '../ImplementData/components/Filter/useFilter';
import RobotContribution from '../PerfReport/components/Robot/RobotContribution';
import Reception from '../PerfReport/components/Robot/Reception';
import { useQuery } from '@tanstack/react-query';
import { RobotMessageReply } from './RobotMessageReply';
import { useOrgConfigQAEnable } from 'hooks/business/useOrgConfig';

const Content = () => {
  const qaEnable = useOrgConfigQAEnable();
  const filterCtx = useDashboardFilter();

  const fetchParams = useMemo(() => {
    return {
      ...ctx2FetchParam(filterCtx),
      qaIs: qaEnable,
    };
  }, [filterCtx, qaEnable]);

  const { data } = useQuery({
    queryKey: ['getRobotContributionOverview', fetchParams],
    queryFn: () => getRobotContributionOverview(fetchParams),
  });

  return (
    <>
      <Banner value={data} />
      <RobotMessageReply />
      {qaEnable ? <Reception /> : null}
      <RobotContribution />
    </>
  );
};

export const RobotReply = () => {
  return (
    <FilterProvider
      initialValue={initialValue}
      rightExtra={(props) => <ExtraNode {...props} showQuickActions />}
      dashboardName="AIReplyRobotReply"
      scene="ASSISTANT_PERFORMANCE"
      showPlatformAll
    >
      <Content />
    </FilterProvider>
  );
};
